import { Wishlist, WishlistEntry } from "../../../../api/model/wishlist";
import { userId } from "./f-wishlist-config";
import { Entry, Product } from "@apis/model/core";

export function countWishlistEntries(wishlists: Wishlist[]): number {
  if (wishlists === null || wishlists.length === 0) {
    return 0;
  }

  let total = 0;
  for (const wishlist of wishlists) {
    total += wishlist.entries.length;
  }

  return total;
}

export function mapWishlistEntry(wishlistEntry: WishlistEntry): Entry {
  const product: Product = {
    name: wishlistEntry.product.name,
    codes: wishlistEntry.product.codes, //TT custom
    url: wishlistEntry.product.url,
    purchasable: true,
    price: wishlistEntry.product.price,
    stock: null,
    images: null,
  };

  return {
    quantity: wishlistEntry.quantity,
    basePrice: null,
    totalPrice: wishlistEntry.totalPrice,
    product: product,
  };
}

export function isAnonymous(): boolean {
  return userId === "anonymous";
}
